export default __webpack_public_path__ + "static/media/teacoffee.9695e57a.png";